const Events = {};

export default Events;
